module.exports = __webpack_public_path__ + "img/spmga-logo.e174cd76.svg";